import { render, staticRenderFns } from "./DateInfo.vue?vue&type=template&id=d5931c8e&"
import script from "./DateInfo.vue?vue&type=script&lang=ts&"
export * from "./DateInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports